module.exports = __webpack_public_path__ + "e27c4503f52cf56907c3440466e06179.png";